import { defineApiInterceptor } from '@kouzoh/merpay-api-client';

export const createRetryInterceptor = (timeout = 3000, maxRetry = 3) =>
  defineApiInterceptor({
    name: 'retry',
    onInit({ options }) {
      options.timeout = timeout;
      options.retry = maxRetry;
      options.retryDelay = 500;
      options.retryStatusCodes = [503];
    },
  });
